import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

const WhyChooseUs = ({ language, content }) => {
  const [expandedCard, setExpandedCard] = useState(null);
  const t = content[language];

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <>
      <style>{`
        .why-section {
          padding: 80px 0;
          position: relative;
          overflow: hidden;
          background:linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #fff5f2 100%)
        }

        .why-section::before {
          content: '';
          position: absolute;
          top: -100px;
          left: -100px;
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%);
          border-radius: 50%;
        }

        .why-section::after {
          content: '';
          position: absolute;
          bottom: -150px;
          right: -150px;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(255, 140, 66, 0.08) 0%, transparent 70%);
          border-radius: 50%;
        }

        .why-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
        }

        .why-card {
          background: white;
          padding: 28px;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          gap: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          border: 2px solid transparent;
        }

        .why-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #ff6b35 0%, #ff8c42 100%);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .why-card:hover::before {
          transform: scaleX(1);
        }

        .why-card:hover {
          box-shadow: 0 8px 32px rgba(255, 107, 53, 0.2);
          transform: translateY(-4px);
          border-color: #ffe5dc;
        }

        .why-card-header {
          display: flex;
          align-items: flex-start;
          gap: 16px;
        }

        .why-icon {
          width: 28px;
          height: 28px;
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 4px;
          box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
        }

        .why-card-title {
          color: #333;
          font-weight: 600;
          font-size: 16px;
          flex: 1;
        }

        .why-card-detail {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
          margin-left: 40px;
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .why-card.expanded .why-card-detail {
          max-height: 200px;
          opacity: 1;
          margin-top: 8px;
        }

        .why-card.expanded {
          background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
          box-shadow: 0 12px 40px rgba(255, 107, 53, 0.25);
          border-color: #ff6b35;
        }

        .expand-indicator {
          position: absolute;
          top: 28px;
          right: 28px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: bold;
          transition: transform 0.3s ease;
          box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
        }

        .why-card.expanded .expand-indicator {
          transform: rotate(45deg);
        }
      `}</style>

      <section id="about" className="why-section">
        <div className="container">
          <div className="section-header">
            <h2>{t.why.title}</h2>
          </div>

          <div className="why-grid">
            {t.why.points.map((point, index) => (
              <div 
                key={index} 
                className={`why-card ${expandedCard === index ? 'expanded' : ''}`}
                onClick={() => toggleCard(index)}
              >
                <div className="why-card-header">
                  <div className="why-icon">
                    <ChevronRight color="white" size={16} />
                  </div>
                  <p className="why-card-title">{point.title}</p>
                </div>
                <div className="why-card-detail">
                  {point.detail}
                </div>
                <div className="expand-indicator">+</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;

// import React, { useState } from 'react';
// import { 
//   Shield, Clock, Award, Users, Sparkles, TrendingUp, 
//   Heart, Star, CheckCircle2, Zap 
// } from 'lucide-react';

// const iconMap = {
//   0: Shield,
//   1: Clock,
//   2: Award,
//   3: Users,
//   4: Sparkles,
//   5: TrendingUp,
//   6: Heart,
//   7: Star
// };

// const WhyChooseUs = ({ language, content }) => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [selectedCard, setSelectedCard] = useState(0);
//   const t = content[language];

//   return (
//     <>
//       <style>{`
//         .why-section {
//           padding: 100px 0;
//           background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #fff5f2 100%);
//           position: relative;
//           overflow: hidden;
//         }

//         .why-section::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: 
//             radial-gradient(circle at 20% 30%, rgba(255, 107, 53, 0.08) 0%, transparent 50%),
//             radial-gradient(circle at 80% 70%, rgba(255, 140, 66, 0.06) 0%, transparent 50%);
//           pointer-events: none;
//         }

//         .section-header {
//           text-align: center;
//           margin-bottom: 60px;
//           position: relative;
//           z-index: 1;
//         }

//         .section-header h3 {
//           font-size: 46px;
//           color: #1a1a1a;
//           margin-bottom: 16px;
//           font-weight: 700;
//           background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }

//         .section-header p {
//           font-size: 18px;
//           color: #666;
//           max-width: 700px;
//           margin: 0 auto;
//         }

//         .why-container {
//           display: grid;
//           grid-template-columns: 1fr 1.5fr;
//           gap: 40px;
//           max-width: 1300px;
//           margin: 0 auto;
//           position: relative;
//           z-index: 1;
//         }

//         .why-sidebar {
//           display: flex;
//           flex-direction: column;
//           gap: 16px;
//           position: sticky;
//           top: 100px;
//           height: fit-content;
//         }

//         .why-tab {
//           padding: 24px;
//           background: white;
//           border-radius: 16px;
//           border: 2px solid #f0f0f0;
//           cursor: pointer;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           display: flex;
//           align-items: center;
//           gap: 16px;
//           position: relative;
//           overflow: hidden;
//         }

//         .why-tab::before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 0;
//           bottom: 0;
//           width: 4px;
//           background: linear-gradient(180deg, #ff6b35 0%, #ff8c42 100%);
//           transform: scaleY(0);
//           transition: transform 0.4s ease;
//         }

//         .why-tab:hover {
//           border-color: #ff6b35;
//           transform: translateX(8px);
//           box-shadow: 0 8px 24px rgba(255, 107, 53, 0.15);
//         }

//         .why-tab:hover::before {
//           transform: scaleY(1);
//         }

//         .why-tab.active {
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-color: #ff6b35;
//           transform: translateX(8px);
//           box-shadow: 0 12px 32px rgba(255, 107, 53, 0.3);
//         }

//         .why-tab.active::before {
//           transform: scaleY(1);
//           background: white;
//         }

//         .why-tab-icon {
//           width: 48px;
//           height: 48px;
//           border-radius: 12px;
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #ff6b35;
//           transition: all 0.4s ease;
//           flex-shrink: 0;
//         }

//         .why-tab.active .why-tab-icon {
//           background: rgba(255, 255, 255, 0.2);
//           color: white;
//           transform: scale(1.1) rotate(5deg);
//         }

//         .why-tab-content {
//           flex: 1;
//         }

//         .why-tab-title {
//           font-size: 16px;
//           font-weight: 600;
//           color: #1a1a1a;
//           margin-bottom: 4px;
//           transition: color 0.3s;
//         }

//         .why-tab.active .why-tab-title {
//           color: white;
//         }

//         .why-tab-number {
//           font-size: 12px;
//           color: #999;
//           font-weight: 500;
//           transition: color 0.3s;
//         }

//         .why-tab.active .why-tab-number {
//           color: rgba(255, 255, 255, 0.8);
//         }

//         .why-main-content {
//           background: white;
//           border-radius: 24px;
//           padding: 48px;
//           border: 2px solid #f0f0f0;
//           box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
//           position: relative;
//           overflow: hidden;
//           animation: slideIn 0.5s ease;
//         }

//         @keyframes slideIn {
//           from {
//             opacity: 0;
//             transform: translateX(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         .why-main-content::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -50%;
//           width: 100%;
//           height: 100%;
//           background: radial-gradient(circle, rgba(255, 107, 53, 0.05) 0%, transparent 70%);
//           pointer-events: none;
//         }

//         .why-content-header {
//           display: flex;
//           align-items: center;
//           gap: 20px;
//           margin-bottom: 32px;
//           position: relative;
//         }

//         .why-content-icon {
//           width: 80px;
//           height: 80px;
//           border-radius: 20px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           box-shadow: 0 12px 32px rgba(255, 107, 53, 0.4);
//           animation: iconPulse 2s infinite;
//         }

//         @keyframes iconPulse {
//           0%, 100% {
//             transform: scale(1);
//             box-shadow: 0 12px 32px rgba(255, 107, 53, 0.4);
//           }
//           50% {
//             transform: scale(1.05);
//             box-shadow: 0 16px 40px rgba(255, 107, 53, 0.5);
//           }
//         }

//         .why-content-title-area h4 {
//           font-size: 32px;
//           color: #1a1a1a;
//           margin-bottom: 8px;
//           font-weight: 700;
//         }

//         .why-content-subtitle {
//           font-size: 16px;
//           color: #666;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .why-content-body {
//           position: relative;
//         }

//         .why-content-description {
//           font-size: 17px;
//           color: #555;
//           line-height: 1.8;
//           margin-bottom: 32px;
//         }

//         .why-features-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 20px;
//           margin-top: 32px;
//         }

//         .why-feature-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 12px;
//           padding: 16px;
//           background: linear-gradient(135deg, #fff5f2 0%, #ffffff 100%);
//           border-radius: 12px;
//           border: 1px solid #ffe5dc;
//           transition: all 0.3s ease;
//         }

//         .why-feature-item:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 8px 20px rgba(255, 107, 53, 0.1);
//           border-color: #ff6b35;
//         }

//         .why-feature-icon {
//           width: 32px;
//           height: 32px;
//           border-radius: 8px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           flex-shrink: 0;
//         }

//         .why-feature-text {
//           flex: 1;
//         }

//         .why-feature-title {
//           font-size: 15px;
//           font-weight: 600;
//           color: #1a1a1a;
//           margin-bottom: 4px;
//         }

//         .why-feature-desc {
//           font-size: 13px;
//           color: #666;
//         }

//         .why-stats {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//           margin-top: 40px;
//           padding-top: 40px;
//           border-top: 2px solid #f0f0f0;
//         }

//         .why-stat-item {
//           text-align: center;
//         }

//         .why-stat-number {
//           font-size: 36px;
//           font-weight: 700;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//           margin-bottom: 8px;
//         }

//         .why-stat-label {
//           font-size: 14px;
//           color: #666;
//         }

//         @media (max-width: 1024px) {
//           .why-container {
//             grid-template-columns: 1fr;
//             gap: 32px;
//           }

//           .why-sidebar {
//             position: static;
//             grid-template-columns: repeat(2, 1fr);
//             display: grid;
//           }

//           .why-features-grid {
//             grid-template-columns: 1fr;
//           }

//           .why-stats {
//             grid-template-columns: repeat(3, 1fr);
//           }
//         }

//         @media (max-width: 768px) {
//           .why-section {
//             padding: 60px 0;
//           }

//           .section-header h3 {
//             font-size: 32px;
//           }

//           .why-main-content {
//             padding: 32px 24px;
//           }

//           .why-content-header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 16px;
//           }

//           .why-content-icon {
//             width: 64px;
//             height: 64px;
//           }

//           .why-content-title-area h4 {
//             font-size: 24px;
//           }

//           .why-sidebar {
//             grid-template-columns: 1fr;
//           }

//           .why-stats {
//             grid-template-columns: repeat(3, 1fr);
//             gap: 16px;
//           }

//           .why-stat-number {
//             font-size: 28px;
//           }
//         }
//       `}</style>

//       <section id="about" className="why-section">
//         <div className="container">
//           <div className="section-header">
//             <h3>{t.why.title}</h3>
//             <p>
//               {language === 'mr' 
//                 ? 'आम्ही तुमच्या विश्वासाचे आणि समाधानाचे मूल्य समजतो. आमची प्रत्येक सेवा तुमच्या गरजा लक्षात ठेवून डिझाइन केली आहे.'
//                 : 'We understand the value of your trust and satisfaction. Every service is designed with your needs in mind.'}
//             </p>
//           </div>

//           <div className="why-container">
//             {/* Sidebar Navigation */}
//             <div className="why-sidebar">
//               {t.why.points.map((point, index) => {
//                 const Icon = iconMap[index] || Shield;
//                 return (
//                   <div
//                     key={index}
//                     className={`why-tab ${selectedCard === index ? 'active' : ''}`}
//                     onClick={() => setSelectedCard(index)}
//                     onMouseEnter={() => setHoveredCard(index)}
//                     onMouseLeave={() => setHoveredCard(null)}
//                   >
//                     <div className="why-tab-icon">
//                       <Icon size={24} />
//                     </div>
//                     <div className="why-tab-content">
//                       <div className="why-tab-title">{point.title}</div>
//                       <div className="why-tab-number">
//                         {language === 'mr' ? `वैशिष्ट्य ${index + 1}` : `Feature ${index + 1}`}
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Main Content Area */}
//             <div className="why-main-content" key={selectedCard}>
//               <div className="why-content-header">
//                 <div className="why-content-icon">
//                   {React.createElement(iconMap[selectedCard] || Shield, { size: 40 })}
//                 </div>
//                 <div className="why-content-title-area">
//                   <h4>{t.why.points[selectedCard].title}</h4>
//                   <div className="why-content-subtitle">
//                     <CheckCircle2 size={16} color="#ff6b35" />
//                     {language === 'mr' ? 'प्रमाणित आणि विश्वासार्ह' : 'Certified & Trusted'}
//                   </div>
//                 </div>
//               </div>

//               <div className="why-content-body">
//                 <div className="why-content-description">
//                   {t.why.points[selectedCard].detail}
//                 </div>

//                 <div className="why-features-grid">
//                   <div className="why-feature-item">
//                     <div className="why-feature-icon">
//                       <Zap size={16} />
//                     </div>
//                     <div className="why-feature-text">
//                       <div className="why-feature-title">
//                         {language === 'mr' ? 'जलद प्रक्रिया' : 'Fast Processing'}
//                       </div>
//                       <div className="why-feature-desc">
//                         {language === 'mr' ? 'त्वरित सेवा प्रदान' : 'Quick service delivery'}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="why-feature-item">
//                     <div className="why-feature-icon">
//                       <Shield size={16} />
//                     </div>
//                     <div className="why-feature-text">
//                       <div className="why-feature-title">
//                         {language === 'mr' ? 'सुरक्षित' : 'Secure'}
//                       </div>
//                       <div className="why-feature-desc">
//                         {language === 'mr' ? '100% डेटा संरक्षण' : '100% data protection'}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="why-feature-item">
//                     <div className="why-feature-icon">
//                       <Users size={16} />
//                     </div>
//                     <div className="why-feature-text">
//                       <div className="why-feature-title">
//                         {language === 'mr' ? 'तज्ञ सहाय्य' : 'Expert Support'}
//                       </div>
//                       <div className="why-feature-desc">
//                         {language === 'mr' ? 'व्यावसायिक मार्गदर्शन' : 'Professional guidance'}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="why-feature-item">
//                     <div className="why-feature-icon">
//                       <Award size={16} />
//                     </div>
//                     <div className="why-feature-text">
//                       <div className="why-feature-title">
//                         {language === 'mr' ? 'गुणवत्ता' : 'Quality'}
//                       </div>
//                       <div className="why-feature-desc">
//                         {language === 'mr' ? 'उत्कृष्ट सेवा मानक' : 'Excellent service standards'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="why-stats">
//                   <div className="why-stat-item">
//                     <div className="why-stat-number">99%</div>
//                     <div className="why-stat-label">
//                       {language === 'mr' ? 'यशाचा दर' : 'Success Rate'}
//                     </div>
//                   </div>
//                   <div className="why-stat-item">
//                     <div className="why-stat-number">24/7</div>
//                     <div className="why-stat-label">
//                       {language === 'mr' ? 'उपलब्धता' : 'Availability'}
//                     </div>
//                   </div>
//                   <div className="why-stat-item">
//                     <div className="why-stat-number">500+</div>
//                     <div className="why-stat-label">
//                       {language === 'mr' ? 'समाधानी ग्राहक' : 'Happy Clients'}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default WhyChooseUs;